class Cell implements UniqIdMarked {
    public cellX:number;
    public cellY:number;
    public actors:Array<Mob> = [];
    private _cachHealth:number = -1;
    public building:Building = null;
    public uniqId:number;
    
    public constructor(cellX:number, cellY:number) {
        this.uniqId = UniqIdGenerator.getUniq();
        this.cellX = cellX;
        this.cellY = cellY;
    }
    
    public addActor(actor:Mob):Mob {
        if (actor.cell) {
            throw new PandaError('attempt to add actor with cell');
        }
        actor.cell = this;
        this.actors.push(actor);
        this._cachHealth = -1;
        return actor;
    }  
    
    public removeActor(actor:Mob):Mob {
        if (actor.cell !== this) {
            throw new PandaError('attempt to remove actor who is not child of this cell');
        }
        let index = this.actors.indexOf(actor);
        if (index < 0) {
            throw new PandaError('Attemt to remove actor from cell that does not contain this actor');
        }
        actor.cell = null;
        this._cachHealth = -1;
        return this.actors.splice(index, 1)[0];
    }
    
    public getSummaryHealth():number {
        if (this._cachHealth == -1) { 
            let l = this.actors.length;
            let acc = 0;
            for (let i =0; i < l; i++) {
                let actor = this.actors[i];
                if (!(actor instanceof Building)) {
                    acc += actor.health;
                }
                
            }
            this._cachHealth = acc;
        }
        return this._cachHealth;
    }
}